/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'

const FullBleedImageCalloutSection = ({ cta, description, image, title }) => {
  return (
    <Box bg="#FBFEFF">
      <Container>
        <Grid columns={[null, 2]} sx={{ alignItems: 'center', rowGap: 0 }}>
          <Box
            ml={[-2, -3]}
            mr={[-2, 0]}
            sx={{
              '@media only screen and (min-width: 1170px)': {
                ml: 0,
              },
            }}
          >
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.description}
              loading="eager"
            />
          </Box>
          <Box py={4}>
            <Heading as="h2" variant="title2" mt={0} mb={1}>
              {title}
            </Heading>
            {description && (
              <Box
                mb={1}
                sx={{
                  variant: 'text.body2',
                  maxWidth: '460px',
                  p: { m: 0 },
                  a: {
                    variant: 'text.link',
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
            {cta}
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default FullBleedImageCalloutSection
